import { IRemitDetails } from "us.collection.economy/interfaces";

export const initialState: IRemitDetails = {
  remittedDetails: {
    data: [],
    isLoading: true,
  }
};
